<template>
  <div ref="thisStep">
    <div class="frankinForm__stepTwo step">

      <div class="in container">
        <section class="formIntro">
          <div class="in container">
            <h4>Step 2 of {{ $store.getters['QuoteForm/maxSteps'] }} - Your postage requirements</h4>
            <p>Tell us about how you spend your postage and what you send, the more detail here the better as this will help us to more accurately determine the best machine for you and the additional postage savings available.</p>

            <p><strong>Not a fan of forms? Click here to request a call back and have one of our Mailing Experts
              provide a quote for you.</strong></p>

            <p>Top tip: If you are currently in a contract, please have this handy to answer any questions our
              Expert may have.</p>

            <a href="/quotes-create?form=callback" class="btn btn-col">
              Request a call back
            </a>

            <!--<a href="#" class="btn btn&#45;&#45;base" tabindex="0" v-if="currentStep == 1">Lets Go!</a>-->
            <!--<a href="#" class="btn btn--base" tabindex="0" v-if="currentStep > 1" @click="stepBack">Go Back</a>-->
          </div>
        </section>

<!--        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.postage_period}">-->
<!--          <div class="inputPanel__col inputPanel__question">-->
<!--            <label>-->
<!--              Please confirm whether the volumes entered below are daily, weekly, monthly or yearly;-->
<!--              <div class="inputPanel__col inputPanel__info">-->
<!--                <div class="infoIcon" data-tip="Info here">-->
<!--                  i-->
<!--                </div>-->
<!--              </div>-->
<!--              <br>-->
<!--            </label>-->
<!--            <label :class="{'white-text': invalidFields.postage_period}">-->
<!--              If you don't have this detail please choose 'I don't have this info' and provide a guide to your average volumes. Please note; the more detail provided the higher the accuracy of the return investment and savings summary presented.-->
<!--            </label>-->
<!--          </div>-->
<!--          <div class="inputPanel__col inputPanel__input inputPanel__input&#45;&#45;groupFull">-->
<!--            <select name="itemsperclassandformat" v-model="postage_period">-->
<!--              <option disabled :value="null">Please Select</option>-->
<!--              <option v-for="title, value in postagePeriods" :value="value">{{ title }}</option>-->
<!--            </select>-->
<!--          </div>-->
<!--          <error-modal>-->
<!--            For a guide on how to obtain this information from the Quadient (Neopost) or Pitney Bowes portal <a href="https://themailingexpert.com/prodsupport/online-portal-guide/" target="_blank">click here</a> or 'Live chat' with us so we can support.-->
<!--            <br>-->
<!--            Frama does not offer this level of detail.-->
<!--            <br>-->
<!--            FP does not offer this level of detail unless you are using Navigator plus on your FP machine.-->
<!--            <br>-->
<!--            If you do not have this detail and would like to proceed with your quote based on you estimated typical volumes please proceed, or you can utilise our infromation gathering service. This service allows us on your consent to gather all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to understand more and to request this free service.**-->
<!--          </error-modal>-->
<!--          <info-modal>-->
<!--            For a guide on how to obtain this information from the Quadient (Neopost) or Pitney Bowes portal <a href="https://themailingexpert.com/prodsupport/online-portal-guide/" target="_blank">click here</a> or 'Live chat' with us so we can support.-->
<!--            <br>-->
<!--            Frama does not offer this level of detail.-->
<!--            <br>-->
<!--            FP does not offer this level of detail unless you are using Navigator plus on your FP machine.-->
<!--            <br>-->
<!--            If you do not have this detail and would like to proceed with your quote based on you estimated typical volumes please proceed, or you can utilise our infromation gathering service. This service allows us on your consent to gather all necessary information and detail on your behalf. <a href="https://themailingexpert.com/let-us-do-it-for-you/" target="_blank">Click here</a> to understand more and to request this free service.**-->
<!--          </info-modal>-->
<!--        </div>-->

        <div v-if="postage_period && postage_period == 'no_info'">
          <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.letters_a_day}">
            <div class="inputPanel__col inputPanel__question">
              <label>How many letters do you send a day on average?</label>
              <div class="inputPanel__col inputPanel__info">
                <div class="infoIcon" data-tip="Info here">
                  i
                </div>
              </div>
            </div>
            <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
              <input type="number" class="inputLarge" name="letteradayonaverage" id="letteradayonaverage" placeholder="Enter Value" v-model="letters_a_day" v-positive-numbers-only/>
            </div>
            <error-modal>
              Please confirm to the best of your ability the average number of letters you process each day.
              <br>
              We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.
            </error-modal>
            <info-modal>
              Please confirm to the best of your ability the average number of letters you process each day.
              <br>
              We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.
            </info-modal>
          </div>


          <div class="inputPanel">
            <div class="inputPanel__col inputPanel__question">
              <label>Slide the percentage value to show the split between classes used
                <div class="inputPanel__col inputPanel__info">
                  <div class="infoIcon" data-tip="Info here">
                    i
                  </div>
                </div>
                <span>
              </span>
              </label>
              <label>
                We understand this may not be exact so please confirm to the best of your knowledge so we have a guide on usage.
              </label>
            </div>
            <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
              <vue-slider ref="slider" v-model="sliderValue" v-bind="sliderOptions" @drag-end="updateClassPercentages"></vue-slider>
              <div style="width:100%;">
                <div style="float:left;">
                  1st class
                </div>
                <div style="float:right;">
                  2nd class
                </div>
                <div style="clear:both;"></div>
              </div>
              <div style="width:100%;">
                <div style="float:left;">
                  {{ class1_postage_percentage_view }} %
                </div>
                <div style="float:right;">
                  {{ class2_postage_percentage_view }} %
                </div>
                <div style="clear:both;"></div>
              </div>
            </div>
            <info-modal>
              Please confirm here your average split between 1st and 2nd class postage e.g. 8 out of 10 letters send are 2nd class so 80% 2nd class and 20% 1st class. We understand you may not know exactly so use your experience and best judgement here.
            </info-modal>
          </div>
        </div>
        <div>

          <form-franking-form-letters v-if="postage_period && postage_period !== 'no_info'"></form-franking-form-letters>

          <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.sendsBulkMailings}">
            <div class="inputPanel__col inputPanel__question">
              <label>Do you send mail shots or bulk mailings in addition to the volumes noted above?</label>
              <div class="inputPanel__col inputPanel__info">
                <div class="infoIcon" data-tip="Info here">
                  i
                </div>
              </div>
            </div>
            <div class="inputPanel__col inputPanel__input">
              <ul class="toggleBtns toggleBtns--inline">
                <li>
                  <input type="radio" id="campaignsyes" name="campaigns" v-model="sendsBulkMailings" :value="true"/>
                  <label for="campaignsyes">yes</label>
                </li>
                <li>
                  <input type="radio" id="campaignsno" name="campaigns" v-model="sendsBulkMailings" :value="false"/>
                  <label for="campaignsno">no</label>
                </li>
              </ul>
            </div>
            <error-modal>
              Lots of businesses send adhoc mailings for invoice runs, statement runs, marketing campaigns etc. Confirm here if you do any such mailings and the typical volumes and frequency of these.
              <br>
              This helps us configure the most suitable machine for you as well as the additional potential postage savings you could benefit from.
            </error-modal>
            <info-modal>
              Lots of businesses send adhoc mailings for invoice runs, statement runs, marketing campaigns etc. Confirm here if you do any such mailings and the typical volumes and frequency of these.
              <br>
              This helps us configure the most suitable machine for you as well as the additional potential postage savings you could benefit from.
            </info-modal>
          </div>


          <div class="inputPanel sub-field-error" :class="{'inputPanel__error' : invalidFields.mailing_volume}" v-if="sendsBulkMailings">
            <error-modal>
              Volume is required
            </error-modal>
            <div class="inputPanel__col inputPanel__question inputPanel__question--right">
              <label style="line-height:45px;padding-right:30px;float:right">Volume</label>
              <div class="inputPanel__col inputPanel__info inputPanel__info--hide">
                <div class="infoIcon" data-tip="Info here">
                  i
                </div>
              </div>
            </div>
            <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
              <input type="text" class="inputLarge inputReg inputReg--left" name="volumeuno" id="volumeuno" placeholder="Enter Value" v-model="mailing_volume" v-positive-numbers-only/>
            </div>
          </div>

          <div class="inputPanel sub-field-error" :class="{'inputPanel__error' : invalidFields.mailing_frequency}" v-if="sendsBulkMailings">
            <error-modal>
              Frequency is required.
            </error-modal>
            <div class="inputPanel__col inputPanel__question inputPanel__question--right">
              <label style="line-height:45px;padding-right:30px;float:right">Frequency</label>
              <div class="inputPanel__col inputPanel__info inputPanel__info--hide">
                <div class="infoIcon" data-tip="Info here">
                  i
                </div>
              </div>
            </div>
            <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
              <select v-model="mailing_frequency">
                <option disabled :value="null">Please Select</option>
                <option v-for="title, value in mailingFrequencies" :value="value">{{ title }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.average_packets_a_day}">
          <div class="inputPanel__col inputPanel__question">
            <label>How many packets, parcels, recorded or special deliveries do you send per day on average?</label>
            <div class="inputPanel__col inputPanel__info">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
            <input type="number" class="inputReg inputReg--left" name="parcelsdoyousendaverage" id="parcelsdoyousendaverage" placeholder="Enter Value" v-model="average_packets_a_day" v-positive-numbers-only/>
          </div>
          <error-modal>
            Please confirm to the best of your ability the average number of packets or parcels you process each day.
            <br>
            We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.
          </error-modal>
          <info-modal>
            Please confirm to the best of your ability the average number of packets or parcels you process each day.
            <br>
            We understand this can often fluctuate so we suggest taking the sum of what you typically send across a monthly period and then divide by 21 to give an average based on working days in a month, this is a good starting point.
          </info-modal>
        </div>

<!--        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.postage_payment}">-->
<!--          <div class="inputPanel__col inputPanel__question">-->
<!--            <label>Would you like to pay for your postage in advance or arrears?-->
<!--              <div class="inputPanel__col inputPanel__info">-->
<!--                <div class="infoIcon" data-tip="Info here">-->
<!--                  i-->
<!--                </div>-->
<!--              </div>-->
<!--            </label>-->
<!--            <label>Only Pitney Bowes and Quadient (Neopost) offer payment in arrears services, choosing payment in arrears may limit your results, fees vary depending on the manufacturer. See (i) for more information.</label>-->
<!--          </div>-->
<!--          <div class="inputPanel__col inputPanel__input">-->
<!--            <ul class="toggleBtns toggleBtns&#45;&#45;inline">-->
<!--              <li>-->
<!--                <input type="radio" id="paypostageadvanced" name="paypostage" v-model="postage_payment" value="advanced"/>-->
<!--                <label for="paypostageadvanced">advance</label>-->
<!--              </li>-->
<!--              <li>-->
<!--                <input type="radio" id="paypostagearrears" name="paypostage" v-model="postage_payment" value="arrears"/>-->
<!--                <label for="paypostagearrears">arrears</label>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <error-modal>-->
<!--            <b>Payment in arrears:</b>-->
<!--            <br>-->
<!--            This service is only available through Pitney Bowes and Quadient (Neopost) at this time.-->
<!--            <br>-->
<!--            This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account.-->
<!--            <br>-->
<!--            Pitney Bowes payment in arrears service is called Purchase Power.-->
<!--            <br>-->
<!--            Quadient (Neopost) is called Neofunds.-->
<!--            <br>-->
<!--            <b>Payment in advance</b>-->
<!--            <br>-->
<!--            The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account.-->
<!--            <br>-->
<!--            For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.-->
<!--            <br>-->
<!--            **Important** By selecting the preference of a payment in arrears service you will limit the manufacturer machines offered to just Pitney Bowes and Quadient (Neopost).-->
<!--          </error-modal>-->
<!--          <info-modal>-->
<!--            <b>Payment in arrears:</b>-->
<!--            <br>-->
<!--            This service is only available through Pitney Bowes and Quadient (Neopost) at this time.-->
<!--            <br>-->
<!--            This service allows businesses to top up franking machines, pulling funds from an agreed credit limit. Rather than an invoice for every postage top up/refill a monthly statement covering all transactions during that monthly billing period is instead sent. This service typically carries higher recrediting fees but reduces the number of invoices to one consolidated monthly statement and means your business doesn't have funds tied up and sitting in a holding account.-->
<!--            <br>-->
<!--            Pitney Bowes payment in arrears service is called Purchase Power.-->
<!--            <br>-->
<!--            Quadient (Neopost) is called Neofunds.-->
<!--            <br>-->
<!--            <b>Payment in advance</b>-->
<!--            <br>-->
<!--            The payment in advance services are available from all manufacturers and require your business to prepay into a deposit/holding account. When your franking machine is refilled/topped up funds will be drawn down from your account.-->
<!--            <br>-->
<!--            For each top up/refill transaction your business will be invoiced for each transaction, plus any associated reset/recrediting charges. On payment of this invoice your holding/deposit account is replenished to the agreed balance ensuring you have suitable funds available for when you next need to top up.-->
<!--            <br>-->
<!--            **Important** By selecting the preference of a payment in arrears service you will limit the manufacturer machines offered to just Pitney Bowes and Quadient (Neopost).-->
<!--          </info-modal>-->
<!--        </div>-->

<!--        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.packets_capacity}">-->
<!--          <div class="inputPanel__col inputPanel__question">-->
<!--            <label>What scale capacity do you require?-->
<!--              <div class="inputPanel__col inputPanel__info">-->
<!--                <div class="infoIcon" data-tip="Info here">-->
<!--                  i-->
<!--                </div>-->
<!--              </div>-->
<!--            </label>-->
<!--            <label>Please select the scale capacity that would facilitate the weighing of the majority of your postage items.<br>Top tip: Opting for a smaller scale can be significantly cheaper. Separate scales can then be used as a cheaper alternative to weigh adhoc items which are too heavy for your linked/integrated scales, all franking machines allow you to then manually enter the weight so you can still frank or print a label for these items.</label>-->
<!--          </div>-->
<!--          <div class="inputPanel__col inputPanel__input">-->
<!--            <ul class="toggleBtns toggleBtns&#45;&#45;fullWidth">-->
<!--              <li>-->
<!--                <input type="radio" id="twothreekg" name="scalecapacity" v-model="packets_capacity" value="2_3"/>-->
<!--                <label for="twothreekg">2 - 3 KG</label>-->
<!--              </li>-->
<!--              <li>-->
<!--                <input type="radio" id="fivekg" name="scalecapacity" v-model="packets_capacity" value="5"/>-->
<!--                <label for="fivekg">5 KG</label>-->
<!--              </li>-->
<!--              <li>-->
<!--                <input type="radio" id="sevenkg" name="scalecapacity" v-model="packets_capacity" value="7"/>-->
<!--                <label for="sevenkg">7 KG</label>-->
<!--              </li>-->
<!--              <li>-->
<!--                <input type="radio" id="tentwelvekg" name="scalecapacity" v-model="packets_capacity" value="10_12"/>-->
<!--                <label for="tentwelvekg">10 - 12 KG</label>-->
<!--              </li>-->
<!--              <li>-->
<!--                <input type="radio" id="thirtythirtyfivekg" name="scalecapacity" v-model="packets_capacity" value="30_35"/>-->
<!--                <label for="thirtythirtyfivekg">30 - 35 KG</label>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <error-modal>-->
<!--            A typical letter weighs arounds 60g and because of this we find most businesses only require a 2-3kg scale, however options up to 30/35kg still exist on Pitney Bowes, Quadient (Neopost) and Frama models.-->
<!--            <br>-->
<!--            **Important** FP only offer linked scale up to 7kg so any weight beyond this will limit your result options to just Pitney Bowes, Quadient (Neopost) and Frama.-->
<!--          </error-modal>-->
<!--          <info-modal>-->
<!--            A typical letter weighs arounds 60g and because of this we find most businesses only require a 2-3kg scale, however options up to 30/35kg still exist on Pitney Bowes, Quadient (Neopost) and Frama models.-->
<!--            <br>-->
<!--            **Important** FP only offer linked scale up to 7kg so any weight beyond this will limit your result options to just Pitney Bowes, Quadient (Neopost) and Frama.-->
<!--          </info-modal>-->
<!--        </div>-->

<!--        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.needsAccountsSpendUnits}">-->
<!--          <div class="inputPanel__col inputPanel__question">-->
<!--            <label>Do you need to break down postage spend by accounts for departmental/business unit spend?</label>-->
<!--            <div class="inputPanel__col inputPanel__info">-->
<!--              <div class="infoIcon" data-tip="Info here">-->
<!--                i-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="inputPanel__col inputPanel__input">-->
<!--            <ul class="toggleBtns toggleBtns&#45;&#45;inline">-->
<!--              <li>-->
<!--                <input type="radio" id="accountsunitspendyes" name="accountsunitspend" v-model="needsAccountsSpendUnits" :value="true"/>-->
<!--                <label for="accountsunitspendyes">yes</label>-->
<!--              </li>-->
<!--              <li>-->
<!--                <input type="radio" id="accountsunitspendno" name="accountsunitspend" v-model="needsAccountsSpendUnits" :value="false"/>-->
<!--                <label for="accountsunitspendno">no</label>-->
<!--              </li>-->
<!--            </ul>-->
<!--          </div>-->
<!--          <error-modal>-->
<!--            Most franking machines come with the ability to add accounts, this allows you to process items under an account in the franking machine and later report on usage. This helps simplify the cross billing and charging to different departments or cost centres.-->
<!--          </error-modal>-->
<!--          <info-modal>-->
<!--            Most franking machines come with the ability to add accounts, this allows you to process items under an account in the franking machine and later report on usage. This helps simplify the cross billing and charging to different departments or cost centres.-->
<!--          </info-modal>-->
<!--        </div>-->

        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.accounts_amount}" v-if="needsAccountsSpendUnits">
          <div class="inputPanel__col inputPanel__question">
            <label>How many accounts are required?</label>
            <div class="inputPanel__col inputPanel__info">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
            <!--<input type="number" class="inputReg" name="accountsarerequired" id="accountsarerequired" placeholder="Enter Value" v-model="accounts_amount"/>-->
            <select v-model="accounts_amount">
              <option disabled selected :value="null">Please Select</option>
              <option :value="9">Up to 9</option>
              <option :value="10">Up to 10</option>
              <option :value="25">Up to 25</option>
              <option :value="30">Up to 30</option>
              <option :value="35">Up to 35</option>
              <option :value="50">Up to 50</option>
              <option :value="100">Up to 100</option>
              <option :value="150">Up to 150</option>
              <option :value="200">Up to 200</option>
              <option :value="300">Up to 300</option>
              <option :value="500">Up to 500</option>
              <option :value="1000">Up to 1000</option>
              <option :value="2000">Up to 2000</option>
              <option :value="3000">Up to 3000</option>
            </select>
          </div>
          <error-modal>
            **Important** The number of accounts chosen may limit your results as not all manufacturers provide up to 3000 accounts available.
          </error-modal>
          <info-modal>
            **Important** The number of accounts chosen may limit your results as not all manufacturers provide up to 3000 accounts available.
          </info-modal>
        </div>

        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.lease_option_2 || invalidFields.lease_option_1}">
          <div class="inputPanel__col inputPanel__question">
            <label>Choose your desired lease terms.
              <div class="inputPanel__col inputPanel__info">
                <div class="infoIcon" data-tip="Info here">
                  i
                </div>
              </div>
              <br>
            </label>
            <label>Top tip: The longer the lease the cheaper your costs and the higher potential savings!</label>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull">
            <span class="labelTop">Lease Option 1</span>
            <select name="quoteoptionsone" v-model="lease_option_1">
              <option disabled selected :value="null">Please Select</option>
              <option value="1" v-if="lease_option_2 != 1">1 year lease term</option>
              <option value="2" v-if="lease_option_2 != 2">2 year lease term</option>
              <option value="3" v-if="lease_option_2 != 3">3 year lease term</option>
              <option value="4" v-if="lease_option_2 != 4">4 year lease term</option>
              <option value="5" v-if="lease_option_2 != 5">5 year lease term</option>
              <option value="6" v-if="lease_option_2 != 6">6 year lease term</option>
            </select>
            <span class="labelTop">Lease Option 2</span>
            <select name="quoteoptionstwo" v-model="lease_option_2">
              <option disabled selected :value="null">Please Select</option>
              <option value="1" v-if="lease_option_1 != 1">1 year lease term</option>
              <option value="2" v-if="lease_option_1 != 2">2 year lease term</option>
              <option value="3" v-if="lease_option_1 != 3">3 year lease term</option>
              <option value="4" v-if="lease_option_1 != 4">4 year lease term</option>
              <option value="5" v-if="lease_option_1 != 5">5 year lease term</option>
              <option value="6" v-if="lease_option_1 != 6">6 year lease term</option>
            </select>
          </div>
          <error-modal>
            **Important**
            Please provide two lease options. This will allow us to provide you with a price comparison on two lease terms to help you understand the best investment for you.
          </error-modal>
          <info-modal>
            Choose your desired lease terms.<br>
            <span>Top tip: The longer the lease the cheaper your costs and the higher your savings!</span>
          </info-modal>
        </div>

        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.quote_confirmation}">
          <div class="inputPanel__col inputPanel__question">
            <label>Would you like an option to purchase?</label>
            <error-modal>
              Required
            </error-modal>
            <div class="inputPanel__col inputPanel__info inputPanel__info--hide">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input">
            <ul class="toggleBtns toggleBtns--inline">
              <li>
                <input type="radio" id="optiontopurchaseyes" name="optiontopurchase" v-model="quote_confirmation" :value="true"/>
                <label for="optiontopurchaseyes">yes</label>
              </li>
              <li>
                <input type="radio" id="optiontopurchaseno" name="optiontopurchase" v-model="quote_confirmation" :value="false"/>
                <label for="optiontopurchaseno">no</label>
              </li>
            </ul>
          </div>
        </div>


<!--        <div class="inputPanel" :class="{'inputPanel__error' : invalidFields.new_solution_custom_date || invalidFields.new_solution_date}">-->
<!--          <div class="inputPanel__col inputPanel__question">-->
<!--            <label>When do you need your new solution?</label>-->
<!--            <div class="inputPanel__col inputPanel__info">-->
<!--              <div class="infoIcon" data-tip="Info here">-->
<!--                i-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="inputPanel__col inputPanel__input inputPanel__input&#45;&#45;groupFull">-->
<!--            <select name="new_solution_date" v-model="new_solution_date">-->
<!--              <option disabled selected :value="null">Please Select</option>-->
<!--              <option value="10_days">Within 10 days</option>-->
<!--              <option value="month">Within a month</option>-->
<!--              <option value="custom_date">Select a date</option>-->
<!--            </select>-->
<!--            <div v-show="new_solution_date === 'custom_date'" class="inputPanel__input inputPanel__input&#45;&#45;groupFull inputPanel__input&#45;&#45;selectaproduct" style="margin-top:10px;">-->
<!--              <input ref="customDate" name="new_solution_custom_date" v-model="new_solution_custom_date" type="date" class="inputReg" placeholder="Select a date">-->
<!--            </div>-->
<!--          </div>-->
<!--          <error-modal>-->
<!--            By confirming an accurate date, this helps us to work to your time line. We can then interact with the provider and yourself to ensure we have everything in place to meet your requirements. The more specific your requirements the better, so we can help plan to this date and support your requirements.-->
<!--          </error-modal>-->
<!--          <info-modal>-->
<!--            By confirming an accurate date, this helps us to work to your time line. We can then interact with the provider and yourself to ensure we have everything in place to meet your requirements. The more specific your requirements the better, so we can help plan to this date and support your requirements.-->
<!--          </info-modal>-->
<!--        </div>-->

        <div class="inputPanel" id="startOfContactDetails">
          <div class="inputPanel__col inputPanel__question">
            <label>Your name</label>
            <div class="inputPanel__col inputPanel__info" style="visibility: hidden">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
            <input id="savename" type="text" name="savename" v-model="name" class="inputLarge" placeholder="Name"/>
          </div>
        </div>

        <div class="inputPanel">
          <div class="inputPanel__col inputPanel__question">
            <label>Company name</label>
            <div class="inputPanel__col inputPanel__info" style="visibility: hidden">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
            <input id="savecompany" type="text" name="savecompany" v-model="company_name" class="inputLarge" placeholder="Company name"/>
          </div>
        </div>

        <div class="inputPanel">
          <div class="inputPanel__col inputPanel__question">
            <label>Contact phone number</label>
            <div class="inputPanel__col inputPanel__info" style="visibility: hidden">
              <div class="infoIcon" data-tip="Info here">
                i
              </div>
            </div>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
            <input id="savetelephone" type="text" name="savetelephone" v-model="contact_phone" class="inputLarge" placeholder="Phone"/>
          </div>
        </div>

        <div class="inputPanel" ref="contact">
          <div class="inputPanel__col inputPanel__question">
            <label>
              Contact preferences
              <div class="inputPanel__col inputPanel__info" style="visibility: hidden">
                <div class="infoIcon" data-tip="Info here">
                  i
                </div>
              </div>
              <br><br>
            </label>
            <label>We may send you news, offers, products and promotions we believe would be of interest to you. If you would like to opt out from our marketing communications please edit your contact preferences.<br><br>Themailingexpert.com takes data protection seriously as set out in our <a href="https://themailingexpert.com/legal-privacy/" target="_blank">privacy policy</a></label>
          </div>
          <div class="inputPanel__col inputPanel__input inputPanel__input--groupFull inputPanel__input--selectaproduct">
            <div class="frmInline row" style="justify-content:center;">
              <div style="flex: 50%;">
                <div style="margin-bottom: 25px;">
                  <input id='contactbyemailspec' type="radio" class="marketing contact_by_email_spec" style="margin-bottom: 10px" @click="preferences_email = !preferences_email" :value="true" v-model="preferences_email"><br><span>Email</span>
                </div>
                <div>
                  <input id="contactbyphonespec" type="radio" class="marketing contact_by_phone_spec" style="margin-bottom: 10px" @click="preferences_phone = !preferences_phone" :value="true" v-model="preferences_phone"><br><span>Phone</span>
                </div>
              </div>

              <div style="flex: 50%;">
                <div style="margin-bottom: 25px;">
                  <input id="contactbymailspec" type="radio" class="marketing contact_by_mail_spec" style="margin-bottom: 10px" @click="preferences_mail = !preferences_mail" :value="true" v-model="preferences_mail"><br><span>Mail</span>
                </div>
                <div>
                  <input id="contactbysmsspec" type="radio" class="marketing contact_by_sms_spec" style="margin-bottom: 10px" @click="preferences_sms = !preferences_sms" :value="true" v-model="preferences_sms"><br><span>SMS</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="inputPanel">
          <div class="inputPanel__col inputPanel__question">
            <label></label>
          </div>
          <div class="inputPanel__col inputPanel__input" style="text-align: center">
            <input type="submit" value="Save & Continue" @click.prevent="submitForm" class="btn btn-gradient" id="detailsStep2Submit" style="border: none; padding: 10px 20px; border-radius: 10px;" />
          </div>
        </div>

        <div class="inputPanel">
          <div class="inputPanel__col inputPanel__question">
            <input id="inputPanelQuestion" type="submit" value="< Back" @click.prevent="stepBack()" class="form-back-button"/>
          </div>
        </div>

        <invalid-fields v-if="invalidFields && Object.keys(invalidFields).length > 0"></invalid-fields>

      </div>
    </div>

    <!---
    <div class="frankinForm__saveProgress saveProgress saveProgress--full saveProgress--paddingLarge">
      <div class="in container">
        <div class="saveProgress__content">
          <h4>TIME TO SAVE YOUR PROGRESS!</h4>
          <p>Please enter your details and click continue</p>
        </div>
        <div class="saveProgress__form" style="padding-top:0;">
          <div class="saveProgress__inputBlock">
            <label for="savename">Name:</label>
            <input id="savename" type="text" name="savename" v-model="name"/>
          </div>
          <div class="saveProgress__inputBlock">
            <label for="savecompany">Company Name:</label>
            <input id="savecompany" type="text" name="savecompany" v-model="company_name"/>
          </div>
          <div class="saveProgress__inputBlock">
            <label for="savetelephone">Contact Telephone Number:</label>
            <input id="savetelephone" type="text" name="savetelephone" v-model="contact_phone"/>
          </div>
          <input type="submit" value="Back" @click.prevent="stepBack()"/>
          <input type="submit" value="save" @click.prevent="updateQuote(2)" style="margin-top:10px;"/>
        </div>
      </div>
    </div>
    --->

  </div>
</template>

<script>
  import {mapState, mapMutations, mapActions} from 'vuex'
  import vueSlider from 'vue-slider-component'
  import Form_FrankingFormLetters from './Conditionals/Form_FrankingFormLetters.vue'
  import InfoModal from '../InfoModal.vue'
  import ErrorModal from '../ErrorModal.vue'
  import InvalidFields from '../InvalidFieldsModal.vue'

  export default {
    components: {
      vueSlider,
      'form-franking-form-letters': Form_FrankingFormLetters,
      'info-modal': InfoModal,
      'error-modal': ErrorModal,
      'invalid-fields': InvalidFields,
    },
    data() {
      return {
        scrollBottom: false,
        postagePeriods: {
          'daily': 'Daily',
          'weekly': 'Weekly',
          'monthly': 'Monthly',
          'yearly': 'Yearly',
          'no_info': 'I don\'t have this info'
        },
        scaleSizes: {
          '2_3': '2-3KG',
          '5': '5KG',
          '7': '7KG',
          '10_12': '10-12KG',
          '30_35': '30-35KG',
        },
        mailingFrequencies: {
          'daily': 'Daily',
          'weekly': 'Weekly',
          'monthly': 'Monthly',
          'quarterly': 'Quarterly',
          'half_yearly': 'Half yearly',
          'annualy': 'Annually',
        },
        sliderOptions: {
          min: -50,
          max: 50,
          interval: 1,
          tooltip: false,
          clickable: false,
        },
        class1_postage_percentage_view: 50,
        class2_postage_percentage_view: 50,
      }
    },
    computed: {
      ...mapState('QuoteForm', ['step2', 'step1', 'invalidFields']),

      preferences_email: {
        get() {
          return this.step2.preferences_email
        },
        set(value) {
          this.updateStep2({preferences_email: value})
        }
      },
      preferences_phone: {
        get() {
          return this.step2.preferences_phone
        },
        set(value) {
          this.updateStep2({preferences_phone: value})
        }
      },
      preferences_mail: {
        get() {
          return this.step2.preferences_mail
        },
        set(value) {
          this.updateStep2({preferences_mail: value})
        }
      },
      preferences_sms: {
        get() {
          return this.step2.preferences_sms
        },
        set(value) {
          this.updateStep2({preferences_sms: value})
        }
      },
      name: {
        get() {
          return this.step2.name
        },
        set(value) {
          this.updateStep2({name: value,})
        }
      },
      contact_phone: {
        get() {
          console.log('get contact_phone');
          return this.step2.contact_phone
        },
        set(value) {
          console.log('set contact_phone');
          this.updateStep2({contact_phone: value,})
        }
      },
      company_name: {
        get() {
          console.log('get company_name');
          return this.step2.company_name
        },
        set(value) {
          console.log('set company_name');
          this.updateStep2({company_name: value,})
        }
      },
      sliderValue: {
        get() {
          return this.step2.sliderValue
        },
        set(value) {
          this.class1_postage_percentage_view = 50 - value
          this.class2_postage_percentage_view = 50 + value
          this.updateStep2({sliderValue: value,})
        }
      },
      sendsBulkMailings: {
        get() {
          return this.step2.sendsBulkMailings
        },
        set(value) {
          this.updateStep2({
            sendsBulkMailings: value,
            mailing_frequency: null,
            mailing_volume: null,
          })
        }
      },
      needsAccountsSpendUnits: {
        get() {
          return this.step2.needsAccountsSpendUnits
        },
        set(value) {
          this.updateStep2({
            needsAccountsSpendUnits: value,
            accounts_amount: null
          })
        }
      },

      postage_period: {
        get() {
          return this.step2.postage_period
        },
        set(value) {
          this.sliderValue = 0
          this.sendsBulkMailings = null
          this.updateStep2({
            letters_a_day: null,
            mailing_frequency: null,
            mailing_volume: null,
            class1_postage_percentage: null,
            class2_postage_percentage: null,
            postage_period: value,

          })

          if (value === 'no_info') {

            this.updateStep2({
              class1_standard_letters: null,
              class1_large_100_letters: null,
              class1_large_100_250_letters: null,
              class1_large_250_500_letters: null,
              class1_large_500_750_letters: null,
              class2_standard_letters: null,
              class2_large_100_letters: null,
              class2_large_100_250_letters: null,
              class2_large_250_500_letters: null,
              class2_large_500_750_letters: null,
            })

            this.class1_postage_percentage = 50
            this.class2_postage_percentage = 50
          }
        }
      },

      letters_a_day: {
        get() {
          return this.step2.letters_a_day
        },
        set(value) {
          this.updateStep2({letters_a_day: value,})
        }
      },
      class1_postage_percentage: {
        get() {
          return this.step2.class1_postage_percentage
        },
        set(value) {
          this.updateStep2({class1_postage_percentage: value})
        }
      },
      class2_postage_percentage: {
        get() {
          return this.step2.class2_postage_percentage
        },
        set(value) {
          this.updateStep2({class2_postage_percentage: value})
        }
      },
      mailing_volume: {
        get() {
          return this.step2.mailing_volume
        },
        set(value) {
          this.updateStep2({mailing_volume: value})
        }
      },
      mailing_frequency: {
        get() {
          return this.step2.mailing_frequency
        },
        set(value) {
          this.updateStep2({mailing_frequency: value})
        }
      },
      average_packets_a_day: {
        get() {
          return this.step2.average_packets_a_day
        },
        set(value) {
          this.updateStep2({average_packets_a_day: value})
        }
      },
      postage_payment: {
        get() {
          return this.step2.postage_payment
        },
        set(value) {
          this.updateStep2({postage_payment: value})
        }
      },
      packets_capacity: {
        get() {
          return this.step2.packets_capacity
        },
        set(value) {
          this.updateStep2({packets_capacity: value})
        }
      },
      accounts_amount: {
        get() {
          return this.step2.accounts_amount
        },
        set(value) {
          this.updateStep2({accounts_amount: value})
        }
      },
      lease_option_1: {
        get() {
          return this.step2.lease_option_1
        },
        set(value) {
          this.updateStep2({lease_option_1: value})
        }
      },
      lease_option_2: {
        get() {
          return this.step2.lease_option_2
        },
        set(value) {
          this.updateStep2({lease_option_2: value})
        }
      },
      quote_confirmation: {
        get() {
          return this.step2.quote_confirmation
        },
        set(value) {
          this.updateStep2({quote_confirmation: value})
        }
      },
      new_solution_date: {
        get() {
          return this.step2.new_solution_date
        },
        set(value) {
          if (value === 'custom_date') {
            this.$refs.customDate.click()
          }
          this.updateStep2({
            new_solution_date: value,
            new_solution_custom_date: null
          })
        }
      },
      new_solution_custom_date: {
        get() {
          return this.step2.new_solution_custom_date
        },
        set(value) {
          this.updateStep2({new_solution_custom_date: value})
        }
      },
    },

    mounted: function () {
      if(this.$route.query.scroll_bottom) {
        this.scrollBottom = this.$route.query.scroll_bottom;
      }
      if(this.scrollBottom) this.scrollToElem('contact');
    },

    methods: {
      ...mapMutations('QuoteForm', ['updateStep2', 'stepBack']),
      ...mapActions('QuoteForm', ['updateQuote']),
      updateClassPercentages(slider) {
        this.class1_postage_percentage = this.class1_postage_percentage_view
        this.class2_postage_percentage = this.class2_postage_percentage_view
      },

      scrollToElem(refName) {
        var element = this.$refs[refName];
        var top = element.offsetTop;
        window.scrollTo(0, top);
      },

      submitForm() {
        this.updateQuote(2);

        this.$nextTick(() => {
          if (this.$store.state.QuoteForm.invalidFields) {
            let firstError = this.$refs.thisStep.querySelector('.inputPanel__error')
            firstError.scrollIntoView()
          } else {
            window.scrollTo(0, 0)
          }
        })
      }
    }


  }
</script>
<style lang="scss">
  .vue-slider {
    background: linear-gradient(45deg, #0a70e3 0%, #f81e8c 100%);
  }

  .vue-slider-process {
    background: transparent !important;
  }

  .white-text {
    color: white !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Quotes/Form/Step-2/Form.vue